import React from "react";
import Card from "./Card";
import {
  ClassBundleResponse,
  ClassResponse,
  isBundleResponse,
} from "../services/api.response.service";
import { RouteEndpoints } from "../services/route.service";
import { Link } from "react-router-dom";
import {
  CheckContentProviderIdExist,
  getBundlePayUrl,
} from "../services/app.service";
import { useSelector } from "react-redux";
import { IRootState } from "../redux/states";
import { ReactComponent as UserSVG } from "../assets/svg/user2.svg";

interface Props {
  data: ClassResponse | ClassBundleResponse;
  showUnAuthModal?: () => void;
  classBundles?: boolean;
}

const BundleBadge = () => {
  return (
    <div style={{ padding: "10px", paddingTop: "0px" }}>
      <span
        style={{
          backgroundColor: "#e5ebf6",
          padding: "4px",
          borderRadius: "4px",
          color: "#47627B",
          fontSize: "12px",
        }}
      >
        Bundle
      </span>
    </div>
  );
};

function ClassCard({ data, showUnAuthModal, classBundles = false }: Props) {
  const { ecampus_id } = useSelector(
    (state: IRootState) => state.setting.user!,
  );

  const isBundle = isBundleResponse(data);
  const isBundlePurchased =
    isBundle &&
    (data.classes?.length ?? 0) > 0 &&
    data.classes.every((c) => c.is_subscribed && c.has_paid);

  const linkUrl = isBundle
    ? isBundlePurchased
      ? "#"
      : getBundlePayUrl(data.id)
    : RouteEndpoints.CLASS_DETAILS(String(data.link_name));

  const handleCardClick = (e: React.MouseEvent) => {
    if (isBundle && isBundlePurchased) {
      e.preventDefault();
      return;
    }
    showUnAuthModal?.();
  };

  const linkClassName = "d-flex flex-column text-decoration-none";

  return (
    <Card className="card-block card-stretch card-height product content-card-container">
      <Card.Body className="p-1 d-flex flex-column">
        {!isBundle ? (
          <Link
            to={linkUrl}
            className={linkClassName}
            onClick={handleCardClick}
          >
            <div className="image-block position-relative">
              <img
                src={data.logo_url}
                className="img-fluid h-100 rounded"
                alt="product-img"
              />
            </div>
            <div className="p-1 product-description mt-3 line-height-16">
              <h3 className="mb-1 fs-5 fw-normal two-line-ellipsis">
                {data.name}
              </h3>
              <small className="mb-0 text-body fs-7  one-line-ellipsis">
                <UserSVG />
                {data.content_provider?.name}
              </small>
            </div>
          </Link>
        ) : (
          <a
            href={linkUrl}
            className={linkClassName}
            onClick={handleCardClick}
            target="_blank"
          >
            <div className="image-block position-relative">
              <img
                src={data.classes?.[0]?.logo_url ?? ""}
                className="img-fluid h-100 rounded"
                alt="product-img"
              />
            </div>
            <div className="p-1 product-description mt-3 line-height-16">
              <h3 className="mb-1 fs-5 fw-normal two-line-ellipsis">
                {data.name}
              </h3>
              <p style={{ color: "#9E9E9E" }}>{data.description}</p>
              <small className="mb-0 text-body fs-7  one-line-ellipsis">
                {data.subscription_currency} {data.subscription_amount_month}{" "}
                /mo · {data.classes?.length ?? 0} classes
              </small>
            </div>
          </a>
        )}
        {/*{!CheckContentProviderIdExist() && (*/}
        {/*  <div className="d-flex justify-content-between flex-column">*/}
        {/*    <hr className="hr-horizontal" />*/}
        {/*    <div className="d-flex justify-content-between align-items-center">*/}
        {/* <div>
                <small>
                  <i className="text-warning fa fa-star" />
                  <small className="ms-1">4.3</small>
                </small>
              </div>
              <small className="d-flex align-items-center gap-1">
                <i className="fa fa-language"></i>{" "}
                <span style={{ fontSize: 10 }}>{data.language}</span>
              </small> */}
        {/*<small>*/}
        {/*  {data.category && (*/}
        {/*    <Link*/}
        {/*      to={*/}
        {/*            RouteEndpoints.CATEGORY_DETAILS(*/}
        {/*              String(data.category.link_name)*/}
        {/*            )*/}
        {/*      }*/}
        {/*      className="text-decoration-none"*/}
        {/*      onClick={showUnAuthModal}*/}
        {/*    >*/}
        {/*      {data.category.name}*/}
        {/*    </Link>*/}
        {/*  )}*/}
        {/*</small>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
      </Card.Body>
      {classBundles && <BundleBadge />}
    </Card>
  );
}

export default ClassCard;
